module.exports = __webpack_public_path__ + "static/img/Chanel-Harris-Tavita.f30e060.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete/Chanel-Harris-Tavita.jpg
// module id = iu4J
// module chunks = 0